import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.show,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.show) = $event)),
    header: "Permita o uso do microfone e câmera",
    draggable: false,
    breakpoints: { '960px': '75vw', '640px': '90vw' },
    style: { width: '35vw' },
    modal: true,
    onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCloseModalPermissionBrowser()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", null, [
        _createElementVNode("p", { innerHTML: _ctx.text }, null, 8, _hoisted_1)
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}